import {useRef,useMemo} from "react";
import COMPONENT_MAP from '../Repository/Components.js';

const SKUDetailSalesOrderItem=({parentId,application,userData,parent})=>{
    const list_name='sku_sales_order_items';
    const executeQuery=useRef(true);

    const renderListTab=useMemo(()=>{
        const Component=COMPONENT_MAP['ListTab'];
        return Component?(
            <Component
                parentId={parentId}
                parent={parent}
                application={application}
                userData={userData}
                entityType={'SalesOrderItem'}
                entityParams={['sku_id='+parentId,'_context='+['parent_name=SKU'],'_lang='+application.globalData.lang]}
                list_name={list_name}
                // height={'50vh'}
                file={'SKUDetailSalesOrderItem.js'}
                navigateOnNew={null}
                initialState={{}}
                checkboxSelection={false}
                disableRowSelectionOnClick={true}
                disableSelectionOnClick={true}
                executeQuery={executeQuery}
            />
        ):null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[parentId,application.globalData.dataGridParams[list_name]]);

    return(renderListTab);
}
export default SKUDetailSalesOrderItem;